(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name fuel.controller:FuelCtrl
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() : $element[0].blur();
						});
					});
				}
			}
		})
        .controller('FuelSuppliersCtrl', FuelSuppliersCtrl);

    function FuelSuppliersCtrl(CommonFuelService, FuelSuppliersService, MessageService,
                               CommonMasterData, applicationConstants, PopupManager) {
        var vm = this;
        vm.ctrlName = 'FuelSuppliersCtrl';

        vm.model = {
            searchPanelToggle:true,
            searchCriteria:null,
            masterList: {
                cityList:[],
                statusList:[]
            },
            suppliersList:[],
            initialSearchDone:false,
            selectedSupplier:null,
            selectedSupplierFromSubmit:null,
            editorMode: applicationConstants.EDITOR_STATUS.ADD
        };

        vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
            vm.model.initialSearchDone=false;
        };

        vm.addNewSupplier = function () {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
            vm.model.selectedSupplier = FuelSuppliersService.getNewSupplier();
        };

        vm.changeStatus = function () {

        };

        vm.selectSupplier = function (supplier) {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
            vm.model.selectedSupplier = FuelSuppliersService.setSupplierForEdit(supplier);
        };

        vm.submitSearchSuppliers = function (params) {
            vm.model.initialSearchDone=true;
            vm.model.suppliersList = [];
            vm.addNewSupplier();
            vm.model.searchCriteria = params;
            FuelSuppliersService.setSuppliersSearchCriteria(vm.model.searchCriteria);
            FuelSuppliersService.getSuppliers(
                function (suppliersList) {
                    vm.model.suppliersList = suppliersList;
                    vm.model.searchPanelToggle = false;
                    if(vm.model.suppliersList.length===0){
                        MessageService.error('No records found');
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        vm.submitSupplier = function (action, supplier) {
            vm.model.selectedSupplierFromSubmit = supplier;
            if (action === applicationConstants.EDITOR_STATUS.DELETE){
                //set to delete supplier
                var param = {
                    title: 'Confirmation',
                    messages: ["Do you want to delete this record"],
                    flags: supplier
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
            }else{
                //set to save supplier update or add new
                saveSupplier();
            }
        };

        function saveSupplier() {
            FuelSuppliersService.saveSelectedSupplier(vm.model.selectedSupplierFromSubmit,
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully saved the record!');
                        vm.submitSearchSuppliers(vm.model.searchCriteria);
                        vm.addNewSupplier();
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function confirmDeleteDialog(pass) {
            if(pass==='YES'){
                FuelSuppliersService.deleteSelectedSupplier(vm.model.selectedSupplierFromSubmit,
                    function (response) {
                        MessageService.success('Successfully deleted the record!');
                        vm.submitSearchSuppliers(vm.model.searchCriteria);
                        vm.addNewSupplier();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

      vm.change = function ($event,flag, selectedItems, value) {
        if(flag ==='matchingIndex'){
          setMatchingIndexForAirports(value);
        }
      }

      function setMatchingIndexForAirports(viewValue){
        if(viewValue !== " " && viewValue!== null) {
          angular.forEach(vm.model.masterList.cityList, function(apt) {
            apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
          })
        }
      }

        //load city list
        CommonMasterData.getAirportList(function(cityList){
            vm.model.masterList.cityList = cityList;
            CommonFuelService.setCityList(cityList);
            vm.model.searchCriteria = FuelSuppliersService.getSuppliersSearchCriteria();
            vm.model.searchCriteria.status = CommonFuelService.getDefaultStatus();
            vm.model.selectedSupplier = FuelSuppliersService.getNewSupplier();
            vm.model.masterList.statusList = CommonFuelService.getStatusList();
        },function () {});
    }
}());
